export default {
  "1": "record_konsultacii",
  "2": "record_ochki",
  "3": "record_kontaktnye_linzy",
  "4": "record_ok_linzy",
  "5": "record_lechenie",
}
